'use client';

import React from 'react';
import { useI18n } from '@/i18n/LocaleProvider';

interface SoldOutBadgeProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export default function SoldOutBadge({ size = 'md', className = '' }: SoldOutBadgeProps) {
  const { t } = useI18n();
  const sizeClasses = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-xs px-3 py-1',
    lg: 'text-sm px-4 py-1.5',
  };

  return (
    <span
      className={`sold-out-badge inline-flex items-center gap-1 rounded-full font-bold tracking-widest uppercase text-red-500 ${sizeClasses[size]} ${className}`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-red-500 animate-pulse-glow" />
      {t.common.soldOut}
    </span>
  );
}